import { Modal, Spin, Empty } from 'antd';
import { useEffect, useState } from 'react';
import getInformeFinalPlanOperativo from '../../services/plaOperativo/informeFinalPlanOperativoService';
import FileManagerPP from './FileManagerPP';

const ModalInformeFinalPlanOperativo = ({ visible, onClose, proyecto }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!visible || !proyecto) return;

        const fetchData = async () => {
            setLoading(true);
            const response = await getInformeFinalPlanOperativo(proyecto);
            setData(response.data || []);
            setLoading(false);
        };

        fetchData();
    }, [visible, proyecto]);

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width="95vw"
            style={{ maxWidth: '95vw' }}
            centered
            destroyOnHidden
            title="📄 Informe Final – Plan Operativo"
        >

            {loading ? (
                <div
                    style={{ textAlign: 'center', padding: 40 }}
                    aria-live="polite"
                >
                    <Spin size="large" />
                    <p>Cargando informe final…</p>
                </div>
            ) : data.length === 0 ? (
                <Empty description="No hay información de Informe Final disponible" />
            ) : (
                <FileManagerPP
                    codigo_tarea={{
                        proyecto: data[0]?.pp ?? '',
                        codActividad: data[0]?.codigo_actividad ?? '',
                        actividad: data[0]?.descripcion ?? '',
                        codTarea: data[0]?.codigo_tarea ?? '',
                        tarea: data[0]?.codigo_tarea
                            ? `${data[0]?.codigo_tarea} - ${data[0]?.tarea_descripcion ?? ''}`
                            : '',
                        codIndicador: data[0]?.indicador_id ?? '',
                        indicador: data[0]?.indicador ?? '',
                        codMV: data[0]?.medio_verificacion_id ?? '',
                        medioVerificacion: data[0]?.medio_verificacion ?? '',
                    }}
                    select_proyect={data}
                />
            )}
        </Modal>
    );
};

export default ModalInformeFinalPlanOperativo;
